/**
 * Debug Util
 *
 * @author lgmcjr@celepar.pr.gov.br
 * @since 17/05/2022
 */
import dayjs from 'dayjs'

const DEBUG_ACTIVE = false
const FILE_LIST = [ /* 'menu.js', 'router.js' */ ]

const debugFile = (fileName) => {
  let dbg = false
  if (FILE_LIST.length > 0) {
    dbg = (FILE_LIST.indexOf((fileName || '@@@')) > -1)
  } else {
    dbg = true
  }
  return dbg
}

export default (data, methodName, fileName) => {
  if ((DEBUG_ACTIVE) && (debugFile(fileName))) {
    let out = `(${dayjs().format('YYYY-MM-DD HH:mm:ss:SSS')}) `
    out += (fileName) ? `[${fileName}] => ` : ''
    out += ((methodName) ? `${methodName}()` : '')
    out += (((data !== null) && (data !== undefined))
      ? (((out !== '') && (methodName)) ? ' : ' : '') + JSON.stringify(data) : '')
    console.debug(out)
  }
}
